<template>
  <AdaptiveView @dblclick.native="toFullScreen" @tap.native="toFullScreen">
    <div id="data-view">
      <!-- <dv-full-screen-container> -->
        <div class="main-header">
          <div class="mh-left">
            <dv-border-box-2  style="width: 170px; height: 50px; line-height: 50px; text-align:center; margin-left:200px;">
             {{lineName}} 线
            </dv-border-box-2>
          </div>
          <div class="mh-middle" style="color: #e8e8e8">SMT综合数据看板</div>
          <div class="mh-right" style="color:#e8e8e8;">
            {{nowTime}}
          </div>
        </div>

        <dv-border-box-1 class="main-container">
          <div class="mc-top" style="padding-bottom: 15px">
            <Top-Left-Cmp />
            <!--<Top-Middle-Cmp />-->
            <digital-flop />
            <!--<Top-right-Cmp />-->
          </div>
          <div class="mc-bottom" style="padding-top: 15px">
            <!--<dv-border-box-6 class="bottom-left-container">
              &lt;!&ndash;<dv-decoration-4 class="mcb-decoration-1" style="width:5px;height:45%;" />
              <dv-decoration-4 class="mcb-decoration-2" style="width:5px;height:45%;" />&ndash;&gt;
              &lt;!&ndash;<Bottom-Left-Chart-1 />&ndash;&gt;
              &lt;!&ndash;<water-level-chart />&ndash;&gt;
              &lt;!&ndash;<Bottom-Left-Chart-2 />&ndash;&gt;
              <Bottom-Right-Table-1 />
            </dv-border-box-6>-->

            <div class="bottom-right-container">
              <!--<Bottom-Right-Table-1 />-->
              <!--<Bottom-Right-Table-2 />-->
              <!--<Bottom-Right-Table-3 />
              <Bottom-Right-Table-4 />-->
              <scroll-board-right />
              <scroll-board />
              <marqueee />
              <!--<water-level-chart />-->
              <top-right-cmp />
            </div>
          </div>
        </dv-border-box-1>

      <!-- </dv-full-screen-container> -->
    </div>
  </AdaptiveView>
</template>

<script>
import TopLeftCmp from './TopLeftCmp'
import TopMiddleCmp from './TopMiddleCmp'
import TopRightCmp from './TopRightCmp'
import Marqueee from './marquee'

import BottomLeftChart1 from './BottomLeftChart1'
import BottomLeftChart2 from './BottomLeftChart2'

import BottomRightTable1 from './BottomRightTable1'
import BottomRightTable2 from './BottomRightTable2'
import BottomRightTable3 from './BottomRightTable3'
import BottomRightTable4 from './BottomRightTable4'

import digitalFlop from './digitalFlop'
import scrollBoard from './scrollBoard'
import scrollBoardRight from './scrollBoardRight'
import waterLevelChart from './waterLevelChart'

import AdaptiveView from './AdaptiveView'

export default {
  name: 'DataView',
  components: {
    TopLeftCmp,
    TopMiddleCmp,
    TopRightCmp,
    BottomLeftChart1,
    BottomLeftChart2,
    BottomRightTable1,
    BottomRightTable2,
    BottomRightTable3,
    BottomRightTable4,
    digitalFlop,
    scrollBoard,
    scrollBoardRight,
    waterLevelChart,
    Marqueee,
    AdaptiveView
  },
  data () {
    return {
      nowTime: '',
      lineName: '',
      lineId: undefined
    }
  },
  beforeMount(){
    const href = window.location.href
    const str = href.substr(href.indexOf("?")+1,href.length)
    const params = str.split('&')
    const code = params[0].split('=')[1]
    if (code){
      this.lineId = code;
    }
  },
  mounted () {
    this.nowTimes();
    this.getBigScreen();
  },
  beforeDestroy () {
    this.clear()
  },
  methods: {
    toFullScreen() {
      console.log("dd");
      document.body.requestFullscreen();
    },
    timeNow(timeStamp) {
      let year = new Date(timeStamp).getFullYear();
      let month =new Date(timeStamp).getMonth() + 1 < 10? "0" + (new Date(timeStamp).getMonth() + 1): new Date(timeStamp).getMonth() + 1;
      let date =new Date(timeStamp).getDate() < 10? "0" + new Date(timeStamp).getDate(): new Date(timeStamp).getDate();
      let hh =new Date(timeStamp).getHours() < 10? "0" + new Date(timeStamp).getHours(): new Date(timeStamp).getHours();
      let mm =new Date(timeStamp).getMinutes() < 10? "0" + new Date(timeStamp).getMinutes(): new Date(timeStamp).getMinutes();
      let ss =new Date(timeStamp).getSeconds() < 10? "0" + new Date(timeStamp).getSeconds(): new Date(timeStamp).getSeconds();
      this.nowTime = year + "-" + month + "-" + date + " "+ hh +":"+ mm +':' + ss ;
    },
    nowTimes(){
      this.timeNow(new Date());
      setInterval(this.nowTimes,1000);
      this.clear()
    },
    //清除定时器
    clear(){
      clearInterval(this.nowTimes)
      this.nowTimes = null;
    },
    async getBigScreen() {
      const data = await this.$http.post('https://apismt.moxitech.cn/admin-api/bigScreen/getWorkOrderLineInfo',{
        lineId: this.lineId
      }).then(res=>{
        return res.data.data
      }).catch(e=>{
        console.log(e)
      });
      this.lineName = data.lineName.replace('-',' ');
    }
  }
}
</script>

<style lang="less">
#data-view {
  width: 100%;
  height: 100%;
  background-color: #030409;
  color: #fff;

  #dv-full-screen-container {
    background-image: url('./img/bg.png');
    background-size: 100% 100%;
    box-shadow: 0 0 3px blue;
    display: flex;
    flex-direction: column;
  }

  .main-header {
    height: 80px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;

    .mh-left {
      font-size: 20px;
      color: rgb(1,134,187);

      a:visited {
        color: rgb(1,134,187);
      }
    }

    .mh-middle {
      font-size: 30px;
    }

    .mh-left, .mh-right {
      width: 350px;
      font-size: 26px;
    }
  }

  .main-container {
    height: calc(~"100% - 80px");

    .mc-top, .mc-bottom {
      box-sizing: border-box;
      padding: 30px;
      display: flex;
    }

    .mc-top {
      height: 40%;
    }

    .mc-bottom {
      height: 60%;
    }

    .top-left-cmp, .bottom-left-container {
      width: 32%;
    }

    .top-middle-cmp, .top-right-cmp {
      width: 34%;
    }

    .bottom-left-container {
      position: relative;

      .border-box-content {
        display: flex;
      }

      .mcb-decoration-1, .mcb-decoration-2 {
        position: absolute;
        left: 50%;
        margin-left: -2px;
      }

      .mcb-decoration-1 {
        top: 5%;
        transform: rotate(180deg);
      }

      .mcb-decoration-2 {
        top: 50%;
      }

      .bottom-left-chart-1, .bottom-left-chart-2 {
        width: 50%;
        height: 100%;
      }
    }

    .bottom-right-container {
      width: 100%;
      /*padding-left: 30px;*/
      box-sizing: border-box;
      display: flex;
    }
  }
}

  .border-box-content{
    padding: unset !important;
  }
</style>
